export default __webpack_public_path__ + "static/countdown_earnest-4eef0b074a76256294c740ba8bad3e50.png";